/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The StreamingResponseBody model module.
 * @module model/StreamingResponseBody
 * @version v0
 */
export default class StreamingResponseBody {
  /**
   * Constructs a new <code>StreamingResponseBody</code>.
   * @alias module:model/StreamingResponseBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>StreamingResponseBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StreamingResponseBody} obj Optional instance to populate.
   * @return {module:model/StreamingResponseBody} The populated <code>StreamingResponseBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new StreamingResponseBody();
    }
    return obj;
  }
}
